<template>
  <div class="accommodation-variants">
    <div class="accommodation-variants_form">
      <booking-form />
    </div>

    <div
      class="accommodation-variants_preloader"
      v-if="isLoading"
    >
      <div class="accommodation-variants_preloader-indicator">
        <div class="accommodation-variants_preloader-indicator-track"></div>
      </div>

      <!-- <div class="accommodation-variants_preloader-blicker"> -->
      <div class="accommodation-variants_container">
        <!-- <div class="accommodation-variants_preloader-blicker-inner"> -->

        <div class="accommodation-variants_item" v-for="i in 8" :key="i">
          <div class="accommodation-variants_preloader-blicker-item-inner"></div>
        </div>

      </div>
    </div>

    <div
      class="accommodation-variants_body"
      v-else
    >
      <div
        class="accommodation-variants_container"
        v-if="Array.isArray(searchedVariantsKeys) && searchedVariantsKeys.length > 0"
      >
        <div
          class="accommodation-variants_item"
          v-for="variantKey in searchedVariantsKeys"
          :key="variantKey"
        >
          <accommodation-variant
            :variantData="getVariantByKey(variantKey)"
          />
        </div>
      </div>

      <div
        class="accommodation-variants_empty-placeholder"
        v-else-if="Array.isArray(searchedVariantsKeys) && searchedVariantsKeys.length === 0"
      >
        <div class="accommodation-variants_empty-placeholder-inner">
          <div class="accommodation-variants_empty-placeholder-img"></div>
          <span class="accommodation-variants_empty-placeholder-title">Нет мест</span>
          <span class="accommodation-variants_empty-placeholder-text">Пожалуйста, выберите другие параметры и повторите поиск или выберите из альтернативных вариантов размещения</span>
        </div>

        <div
          class="accommodation-variants_container"
          v-if="advancedVariantsKeys.length > 0"
        >
          <div
            class="accommodation-variants_item"
            v-for="variantKey in advancedVariantsKeys"
            :key="variantKey"
          >
            <accommodation-variant
              :variantData="getVariantByKey(variantKey)"
              :isAdvanced="true"
            />
          </div>
        </div>
      </div>

      <div
        class="accommodation-variants_empty-placeholder"
        v-else
      >
        <div class="accommodation-variants_empty-placeholder-inner">
          <span class="accommodation-variants_empty-placeholder-text">Пожалуйста, выберите параметры</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookingForm from '@/components/BookingForm'
import AccommodationVariant from '@/components/AccommodationVariant'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'accommodation-variants',

  components: {
    BookingForm,
    AccommodationVariant,
  },

  computed: {
    ...mapState({
      isLoading: state => state.selection.isVariantsFetching,
      // variants: state => state.selection.variants,
      searchedVariantsKeys: state => state.selection.searchedVariantsKeys,
      advancedVariantsKeys: state => state.selection.advancedVariantsKeys,
    }),

    ...mapGetters({
      getVariantByKey: 'selection/getVariantByKey',
    })
  },

  methods: {
    // ...mapActions({
    //   fetchVariants: 'accommodationVariants/fetchVariants',
    // }),
  },
}
</script>

<style lang="sass">
.accommodation-variants
  width: 100%
  min-height: 100%
  display: flex
  flex-direction: column

.accommodation-variants_form
  width: 100%
  // max-width: 1100px
  margin: 0 auto px-em(50)

.accommodation-variants_body
  width: 100%
  // max-width: px-em(1100)
  margin: 0 auto
  overflow: hidden
  flex-grow: 1
  display: flex
  flex-direction: column

  // outline: 1px solid red

.accommodation-variants_container
  width: calc(100% + px-em(24))
  margin-left: px-em(-12)
  margin-right: px-em(-12)
  display: flex
  flex-wrap: wrap

// .accommodation-variants_container-inner
//   min-width: 1px
//   display: flex

//   margin: 0 auto
//   justify-content: center

.accommodation-variants_item
  width: 25%
  max-width: px-em(279)
  flex-shrink: 0
  padding: px-em(10) px-em(12)

  // outline: 1px solid blue

  // &:nth-child(n+5)
  //   margin-top: px-em(20)

.accommodation-variants_empty-placeholder
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  flex-grow: 1
  color: #696D74

.accommodation-variants_empty-placeholder-inner
  // height: 50vh
  margin-bottom: px-em(40)
  max-height: px-em(500)
  display: flex
  flex-direction: column
  // justify-content: center

.accommodation-variants_empty-placeholder-img
  padding-top: px-em(200)
  position: relative

  &::before
    content: ''
    display: block
    width: px-em(180)
    height: px-em(180)
    position: absolute
    top: 0
    left: 50%
    transform: translateX(-50%)
    background-image: url('@/assets/img/empty-variants-bg.png')
    background-repeat: no-repeat
    background-size: contain
    background-position: 50% 50%

.accommodation-variants_empty-placeholder-title
  display: block
  text-align: center
  font-size: 1.125em
  font-weight: 700

.accommodation-variants_empty-placeholder-text
  display: block
  text-align: center


.accommodation-variants_preloader
  display: block
  width: 100%
  position: relative

.accommodation-variants_preloader-indicator
  width: 100%
  height: px-em(10)
  background-color: #777777
  position: absolute
  top: 0
  transform: translateY(-100%)
  margin-top: px-em(-27)

.accommodation-variants_preloader-indicator-track
  position: absolute
  top: 0
  bottom: 0
  left: 0
  width: 100%
  transform: scaleX(.2)
  transform-origin: 0
  background-color: #E9DE01
  border-top-right-radius: px-em(5)
  border-bottom-right-radius: px-em(5)

// .accommodation-variants_preloader-blicker
//   width: 100%
//   max-width: px-em(1100)
//   margin: 0 auto

// .accommodation-variants_preloader-blicker-inner
//   width: calc(100% + px-em(24))
//   margin-left: px-em(-12)
//   margin-right: px-em(-12)
//   display: flex
//   flex-wrap: wrap


// .accommodation-variants_preloader-blicker-item
//   width: 25%
//   padding: 0 px-em(12)

//   &:nth-child(n+5)
//     margin-top: px-em(20)

.accommodation-variants_preloader-blicker-item-inner
  background-color: #EFEFEF
  border-radius: px-em(15)
  min-height: px-em(248)
  position: relative
  overflow: hidden

  &::before
    content: ''
    display: block
    position: absolute
    top: 0
    left: 0
    right: 0
    height: px-em(141)
    background-color: #D9D9D9

  &::after
    content: ''
    display: block
    position: absolute
    bottom: px-em(16)
    left: 50%
    transform: translateX(-50%)
    width: 80%
    max-width: px-em(156)
    height: px-em(44)
    border-radius: px-em(50)
    background-color: #D9D9D9

@media screen and (max-width: $mobile-breakpoint)
  .accommodation-variants_container
    width: 100%
    margin-left: 0
    margin-right: 0
    padding-left: 0
    padding-right: 0

  .accommodation-variants_form
    margin-bottom: px-em(20,12)

  .accommodation-variants_item
    width: 100%
    margin: 0
    padding: 0

    + .accommodation-variants_item
      margin-top: px-em(20, 12)

  .accommodation-variants_preloader-blicker-inner
    width: 100%
    margin-left: 0
    margin-right: 0
    padding-left: 0
    padding-right: 0

  .accommodation-variants_preloader-blicker-item
    width: 100%
    padding: 0

    &:nth-child(n+2)
      margin-top: px-em(20,12)

    &:nth-child(n+3)
      display: none

</style>
